import { apiClient, handleError } from "api/ApiClient";
import ApiEndpoints from "constants/ApiEndpoints";

export const deleteEffect = (id) => (dispatch) => {
  return apiClient
    .delete(`${ApiEndpoints.EFFECTS}${id}`)
    .then(() => {
      return true;
    })
    .catch((err) => {
      dispatch(handleError(err));
      return false;
    });
};
